module.exports = __webpack_public_path__ + "img/图像 2.dc40d988.png";